/** @module csi/heading/StringBarcode */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/heading/_base",
	"csi/heading/String",
	"csi/html",
	"csi/locale",
	"csi/middleware/customView/customViewDataManagementService",
	"csi/widget/Barcode",
], function(declare,domClass,csiHeading,StringRen,html,locale,{stringNonTextFormatOperators},Barcode) {

	return declare(StringRen, {
		queryOps: stringNonTextFormatOperators,

		/**
		 *  @property {Object} barcodeOptions - reference https://github.com/lindell/JsBarcode for available options
		 */
		barcodeOptions: {
			displayValue: false,
			format: "CODE39",
			height: 40,
			margin: 0,
			width: 1.435
		},
		
		/**
		 * Render barcode in own line in properties since it cannot wrap
		 */
		canBeLarge: function(ctx, h) {
			return 2;
		},

		/**
		 * @override
		 * Only allow filtering by blanks and non-blanks
		 */
		getQuerySpec: function(ctx, h, spec) {
			var	qs = this.inherited(arguments);
			qs.allowFilteringBySelectionOfExistingValues = true;
			return qs;
		},

		/**
		 * Render barcode
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			var value = this.toValue(ctx, h);
			if (value) {
				if (ctx.bTooltip) {
					// if rendering in tooltip, just show string value
					html.text(refNode, value);
				} else {
					try {
						// render barcode for display
						var span = html.create("span", {"class": html.CSS_NO_EXPORT}, refNode);
						Barcode.render(span, value, this.barcodeOptions);
						
						// render barcode value for export to excel
						html.create("span", {
							"class": html.CSS_EXPORT,
							innerText: value
						}, refNode);
					} catch(ex) {
						domClass.add(refNode, csiHeading.CSS_ERROR);
						html.text(refNode, value);
					}
				}

				return true;
			}

			return false;
		},

		/**
		 * Throw exception if invalid character entered
		 */
		validateValue: function(ctx, h, value) {
			if (!value) {
				return;
			}

			if (!Barcode.isValidFormat(this.barcodeOptions)) {
				throw new Error(locale.resource("ValidateBarcodeFormat", [this.barcodeOptions.format]));
			}
			
			if (!Barcode.isValidValue(value, this.barcodeOptions)) {
				throw new Error(locale.resource("ValidateBarcode", [this.barcodeOptions.format]));
			}
		}
	});
});